import { SelectOption } from 'global';
import { useQuery } from '@apollo/client';

import { VOApiFilterType } from '../../filters';
import { opportunitiesListApi } from './index';

export function useFiltersOptions(filterTypes: VOApiFilterType[]) {
  const { data, loading, error } = useQuery<
    {
      voFiltersOptions: {
        list: { group: VOApiFilterType; list: SelectOption[] }[];
      };
    },
    { input: { filterTypes: VOApiFilterType[] } }
  >(opportunitiesListApi.getFiltersOptions, {
    variables: {
      input: {
        filterTypes,
      },
    },
  });

  return {
    error,
    loading,
    options: data?.voFiltersOptions?.list ?? [],
  };
}
